import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  
  form!: FormGroup;

  emailAddress: string = '';
  emailSent: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  sendLink() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    this.authService.sendPasswordResetMail(this.getControl('email').value).subscribe((result) => {
      this.emailSent = true;
      this.isLoading = false;
    });
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}